import { jsxs as l, Fragment as C, jsx as e } from "react/jsx-runtime";
const d = () => /* @__PURE__ */ l(C, { children: [
  /* @__PURE__ */ e(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 10.5C12 8.567 13.567 7 15.5 7C17.433 7 19 8.567 19 10.5V14.5C19 16.1756 17.8226 17.5761 16.25 17.9195V20.5C16.25 20.9142 15.9142 21.25 15.5 21.25C15.0858 21.25 14.75 20.9142 14.75 20.5V17.9195C13.1774 17.5761 12 16.1756 12 14.5V10.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ e(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 3.25C7.92893 3.25 6.25 4.92893 6.25 7V14C6.25 15.7248 7.41441 17.1776 9 17.6152V19.75C9 20.1642 9.33579 20.5 9.75 20.5C10.1642 20.5 10.5 20.1642 10.5 19.75V13V12.75V10.5C10.5 8.41869 11.7717 6.6344 13.5804 5.88174C13.1047 4.35685 11.6816 3.25 10 3.25ZM13.75 7.46824V13H12V10.5C12 9.20451 12.7038 8.0734 13.75 7.46824Z",
      fill: "currentColor"
    }
  )
] });
export {
  d as default
};
